import { render, staticRenderFns } from "./AgenciesTable.vue?vue&type=template&id=4f5da385&"
import script from "./AgenciesTable.vue?vue&type=script&lang=js&"
export * from "./AgenciesTable.vue?vue&type=script&lang=js&"
import style0 from "./AgenciesTable.vue?vue&type=style&index=0&id=4f5da385&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports